import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Utilities } from '../../providers/utilities';
import { VotingData } from '../../providers/voting';

@Pipe({
  name: 'votingAnswers',
})
export class VotingAnswersPipe implements PipeTransform {

  constructor(
    private votingData: VotingData,
    private utilities: Utilities
  ) { }

  transform(pollId: string, clientId: string, eventId: string): Observable<any> {
    if (this.utilities.validateEventIdParam(eventId)) {
      return this.votingData.getVotingEventAnswers(clientId, eventId, pollId);
    } else {
      return this.votingData.getVotingAnswers(clientId, pollId);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/voting/voting-answer.ts